import classNames from 'classnames';
import React, { useContext } from 'react';

import ContentPlaceholder from '~/shared/components/content-placeholder';
import ItemsNavigator from '~/shared/components/items-navigator';
import Sorting from '~/shared/components/sorting';
import { RootContext } from '~/shared/configs/root-context';
import { LIST_ITEM_TYPE, PAGE_NAMES } from '~/shared/constants';
import { useTypedTranslation } from '~/shared/hooks';

import './posts-navigator.scss';

const LIMIT_OF_CATEGORIES = 7;

const PostsNavigator = ({
  withLoadMore = true,
  data,
  isNameSortDesc,
  isDateSortDesc,
  setIsDateSortDesc,
  setIsNameSortDesc,
  setActiveCategoryAlias,
  activeCategoryAlias,
  getTagLink,
  refetch,
  uniqueCards = [],
  fetchMore,
  onPostsNavigatorChange,
}) => {
  const rootContext = useContext(RootContext);
  const t = useTypedTranslation(['link']);
  const findManyCategoryData = { findManyCategoryQuery: [] };

  return (
    <div className="posts-navigator">
      <div className={classNames('posts-navigator__content')}>
        {withLoadMore ? (
          <h1 className="posts-navigator__title">{t('text.home-blog-title')}</h1>
        ) : (
          <h3 className="posts-navigator__title">{t('text.home-blog-title')}</h3>
        )}
        <div className={classNames('posts-navigator__title-block')}>
          <div className="posts-navigator__sub-title">{t('text.posts-of-categories')}:</div>
          <Sorting
            t={t}
            isNameSortDesc={isNameSortDesc}
            isDateSortDesc={isDateSortDesc}
            isNameSortDisabled={false}
            onNameSortClick={() => {
              setIsDateSortDesc(null);
              setIsNameSortDesc(!isNameSortDesc);
            }}
            onDateSortClick={() => {
              setIsNameSortDesc(null);
              setIsDateSortDesc(!isDateSortDesc);
            }}
            isDateSortDisabled={false}
          />
        </div>

        <ul itemScope itemType="https://schema.org/ItemList" className="posts-navigator__list">
          {(false ? [...Array(LIMIT_OF_CATEGORIES).keys()] : findManyCategoryData?.findManyCategoryQuery)?.map(
            (item, i) => {
              return (
                <li
                  itemProp="itemListElement"
                  key={item?._id}
                  onClick={() => {
                    onPostsNavigatorChange(item?.alias);
                    setActiveCategoryAlias(item?.alias);
                    refetch({
                      filter: {
                        categoryAlias: item?.alias,
                        language: rootContext?.lng,
                      },
                    });
                  }}
                  className={classNames('posts-navigator__list-item', {
                    'posts-navigator__list-item--active': activeCategoryAlias === item?.alias,
                  })}
                >
                  <div className="posts-navigator__category-title">
                    <ContentPlaceholder isLoading={false} isError={false} content={item?.name} />
                  </div>
                </li>
              );
            },
          )}
        </ul>
        <ItemsNavigator
          showMoreText={t('text.load-more-posts')}
          withLoadMore={withLoadMore}
          lng={rootContext?.lng}
          withPagination={false}
          getTagLink={getTagLink}
          isMobile={false}
          withSortBar={false}
          loading={false}
          filter={{
            filter: {
              categoryAlias: activeCategoryAlias,
              language: rootContext?.lng,
            },
          }}
          uniqueCards={uniqueCards}
          itemType={LIST_ITEM_TYPE.EXTENDED}
          pageToGo={PAGE_NAMES.POST}
          pageTagsToGo={PAGE_NAMES.POSTS_TAGS}
          error={false}
          data={data}
          t={t}
          fetchMore={fetchMore}
        />
      </div>
    </div>
  );
};

export default PostsNavigator;
